import Cookies from "js-cookie";
import axios from "axios";
import {API_BASE_URL} from "../../src/config";

const API_BASE = `${API_BASE_URL}api/Metadata/`;
const headers = { "Content-Type": "application/json" };

const getToken = () => Cookies.get("employeeToken") || "";

// Get Functions ID
export const getFunctions = async () => {
	try {
		const response = await axios.post(
			`${API_BASE}GetFunctions`,
			{ token: getToken() },
			{ headers }
		);
		return response.data.functionDataList || [];
	} catch (error) {
		console.error("Error fetching functions:", error);
		return [];
	}
};

// Get Functions Manager Name
export const getFunctionName = async (functionID) => {
	try {
		const response = await axios.post(
			`${API_BASE}GetFunctions`,
			{
				token: getToken(),
				functionID: parseInt(functionID),
			},
			{ headers }
		);
		return response.data.functionDataList || [];
	} catch (error) {
		console.error("Error fetching functions Name:", error);
		return [];
	}
};

// Get Grades
export const getGrades = async () => {
	try {
		const response = await axios.post(
			`${API_BASE}GetGrades`,
			{ token: getToken() },
			{ headers }
		);
		return response.data.gradeList || [];
	} catch (error) {
		console.error("Error fetching grades:", error);
		return [];
	}
};

// Get Zones
export const getZones = async () => {
	try {
		const response = await axios.post(
			`${API_BASE}GetZones`,
			{ token: getToken() },
			{ headers }
		);
		return response.data.zoneDataList || [];
	} catch (error) {
		console.error("Error fetching zones:", error);
		return [];
	}
};

// Get Departments based on Function ID
export const getDepartments = async (functionID) => {
	try {
		const response = await axios.post(
			`${API_BASE}GetDepartments`,
			{
				token: getToken(),
				function: parseInt(functionID),
			},
			{ headers }
		);
		return response.data.departmentList || [];
	} catch (error) {
		console.error("Error fetching departments:", error);
		return [];
	}
};

// Get Job Locations
export const getJobLocations = async (zoneId) => {
	try {
		const response = await axios.post(
			`${API_BASE}GetJobLocations`,
			{
				token: getToken(),
				zone: parseInt(zoneId),
			},
			{ headers }
		);
		return response.data.jobLocationList || [];
	} catch (error) {
		console.error("Error fetching job locations:", error);
		return [];
	}
};


// Get Role Type
export const getRoleType = async () => {
	try {
		const response = await axios.post(
			`${API_BASE}GetRoleType`,
			{ token: getToken() },
			{ headers }
		);
		return response.data.roleType || [];
	} catch (error) {
		console.error("Error fetching functions:", error);
		return [];
	}
};


// Get Role Type
export const getJobCategory = async () => {
	try {
		const response = await axios.post(
			`${API_BASE}GetJobCategory`,
			{ token: getToken() },
			{ headers }
		);
		return response.data.jobCategory || [];
	} catch (error) {
		console.error("Error fetching functions:", error);
		return [];
	}
};

// Get Employee Details
export const getEmployeeDetails = async (employeeCode) => {
	try {
		const response = await axios.post(
			`${API_BASE}GetEmployeeDetails`,
			{ token: getToken(), employeeCode },
			{ headers }
		);
		return response.data.userDetails || null;
	} catch (error) {
		console.error("Error fetching employee details:", error);
		return null;
	}
};

// Get Consultant Details
export const getConsultantDetails = async (consultantCode) => {
	try {
		const response = await axios.post(
			`${API_BASE}GetConsultantDetails`,
			{ token: getToken(), consultantCode },
			{ headers }
		);
		return response;
	} catch (error) {
		console.error("Error fetching employee details:", error);
		return null;
	}
};

//Harshada Bhavsar (24/7/2025)
// Get Consultant Types API
export const getConsultantTypes = async () => {
	try {
		const response = await axios.post(
			`${API_BASE}GetConsultantType`,
			{ token: getToken() },
			{ headers }
		);
		return response.data.consultantTypeList || [];
	} catch (error) {
		console.error("Error fetching consultant types:", error);
		return [];
	}
};

//Get Answer Types
export const GetAnswerTypes = async () => {
	try {
		const response = await axios.post(
			`${API_BASE}GetAnswerType`,
			{ token: getToken() },
			{ headers }
		);
		return response.data.answerType || [];
	} catch (error) {
		console.error("Error fetching grades:", error);
		return [];
	}
};

//Get Employee Suggestions by searching the name
export const getEmployeeSuggestions = async (searchParameter) => {
  try {
    const response = await axios.post(
      `${API_BASE}GetEmployeeSuggestions`,
      { token: getToken(), searchParameter },
      { headers }
    );
    return response.data.employeeSuggestions || [];
  } catch (error) {
    console.error("Error fetching employee suggestions:", error);
    return [];
  }
};

//Get Employee Suggestions by searching the name
export const getConsultantSuggestions = async (searchParameter) => {
  try {
    const response = await axios.post(
      `${API_BASE}GetConsultantSuggestions`,
      { token: getToken(), searchParameter },
      { headers }
    );
    return response.data.consultantSuggestions || [];
  } catch (error) {
    console.error("Error fetching Consultant suggestions:", error);
    return [];
  }
};